import { render, staticRenderFns } from "./AddDependent.vue?vue&type=template&id=030a1f50&"
import script from "./AddDependent.vue?vue&type=script&lang=js&"
export * from "./AddDependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports